export class Chapter {
    constructor(name, loggedBy, url) {
        this.name = name;
        this.loggedby = loggedBy;
        this.url = url;
    }

    static from_json(json) {
        return new Chapter(json.name, json.loggedBy, json.url);
    }

    get_name() {
        return this.name;
    }

    get_logged_by() {
        return this.loggedby;
    }

    get_url() {
        return this.url;
    }
}